import axiosInstance from "../../../core/axios"

export const sendLead = async (data, day) => {
  try {
    const user = JSON.parse(data)

    await axiosInstance.post('/leads', {
      name: user.name, 
      email: user.email, 
      tel: user.whatsapp, 
      event: day === 1 ? 'alta-gerada-dia-1' : 'alta-gerada-dia-2'
    })

    return true
  } catch (error) {
    console.error(error)
    return null
  }
}